/**
 * local-storage-settings-gateway.js
 * Persists settings in localStorage while normalising default structure.
 */
import { createDefaultSettings as createDefaultSettingsShape, SETTINGS_KEY as DEFAULT_SETTINGS_KEY } from '../domain/settings/default-settings.js';

function createDefaultSettings() {
  return createDefaultSettingsShape();
}

function getStorage(defaultStorage) {
  if (defaultStorage) {
    return defaultStorage;
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage;
  }
  return null;
}

export class LocalStorageSettingsGateway {
  constructor({ storage = null, key = DEFAULT_SETTINGS_KEY } = {}) {
    this.storage = getStorage(storage);
    this.key = key;
  }

  load() {
    if (!this.storage) {
      return createDefaultSettings();
    }

    const defaults = createDefaultSettings();
    const raw = this.storage.getItem(this.key);
    if (!raw) {
      this.storage.setItem(this.key, JSON.stringify(defaults));
      return defaults;
    }

    try {
      const parsed = JSON.parse(raw) || {};
      parsed.prefs = { ...defaults.prefs, ...(parsed.prefs || {}) };
      parsed.profile = { ...defaults.profile, ...(parsed.profile || {}) };
      parsed.organization = { ...defaults.organization, ...(parsed.organization || {}) };
      parsed.last = { ...defaults.last, ...(parsed.last || {}) };

      if (!('tool' in parsed.last)) {
        parsed.last.tool = createDefaultSettingsShape().last.tool;
      }

      return parsed;
    } catch (error) {
      this.storage.removeItem(this.key);
      return this.load();
    }
  }

  save(patch = {}) {
    const base = this.load();
    const next = { ...base, ...patch };
    if (this.storage) {
      this.storage.setItem(this.key, JSON.stringify(next));
    }
    return next;
  }

  clear() {
    if (this.storage) {
      this.storage.removeItem(this.key);
    }
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.LocalStorageSettingsGateway = LocalStorageSettingsGateway;
}
